__turbopack_context__.v({
  "activeHighlight": "za3yna_activeHighlight",
  "contentWrapper": "za3yna_contentWrapper",
  "heading": "za3yna_heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "label": "za3yna_label",
  "metricItem": "za3yna_metricItem",
  "metricsBar": "za3yna_metricsBar",
  "phoneImage": "za3yna_phoneImage",
  "phoneScreen": "za3yna_phoneScreen",
  "phoneWrapper": "za3yna_phoneWrapper",
  "pulseRing": "za3yna_pulseRing",
  "pulseRings": "za3yna_pulseRings",
  "ring": "za3yna_ring",
  "section": "za3yna_section",
  "textBlock": "za3yna_textBlock" + " " + __turbopack_context__.i(515534)["sectionTextBlock"],
  "videoLayer": "za3yna_videoLayer",
});
